module.exports = __webpack_public_path__ + "img/portraits_16_V.e1f1c974.webp";